import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { createFluxTheme } from "./theme";
import { useState, type ReactNode } from "react";
import FluxThemeContext, { ThemeMode } from "./theme-context";

interface FluxThemeProviderProps {
  children: ReactNode;
}

export function FluxThemeProvider({ children }: FluxThemeProviderProps) {
  const [mode, setMode] = useState<ThemeMode>("light");
  return (
    <FluxThemeContext.Provider value={{ mode, setMode }}>
      <MuiThemeProvider theme={createFluxTheme({ mode })}>{children}</MuiThemeProvider>
    </FluxThemeContext.Provider>
  );
}
